"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _actions = require("egov-ui-kit/redux/form/actions");

var _api = require("egov-ui-framework/ui-utils/api");

var _reusableFields = require("egov-ui-kit/config/forms/specs/PropertyTaxPayMutation/utils/reusableFields");

var _actions2 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var premisesTypeStaticData = [{
  label: "HO Govt",
  value: "08"
}, {
  label: "HO Govt",
  value: "17"
}, {
  label: "Kolkata Proper",
  value: "11"
}, {
  label: "HO Bustee",
  value: "12"
}, {
  label: "Multi Storeyed Building",
  value: "14"
}, {
  label: "Kolkata Port Trust",
  value: "16"
}];

var basisData = [{
  label: "HO Govt",
  value: "08"
}, {
  label: "HO Govt",
  value: "17"
}, {
  label: "Kolkata Proper",
  value: "11"
}, {
  label: "HO Bustee",
  value: "12"
}, {
  label: "Multi Storeyed Building",
  value: "14"
}, {
  label: "Kolkata Port Trust",
  value: "16"
}];

var formConfig = {
  name: "propertyAddress",
  fields: {
    // inspector: {
    //   id: "inspector",
    //   jsonPath: "Properties[0].inspector",
    //   type: "textfield",
    //   floatingLabelText: "Inspector",
    //   hintText: "",
    //   numcols: 6,
    //   errorMessage: "required!",
    //   errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
    //   maxLength: 64,
    //   required: true,
    //   updateDependentFields: ({ formKey, field, dispatch, state }) => {
    //     dispatch(setFieldProperty("propertyAddress", "inspector", "value", field.value));
    //     dispatch(prepareFinalObject("Properties[0].inspector", field.value));
    //   },
    // },
    // basis: {
    //   id: "basis",
    //   jsonPath: "Properties[0].basis",
    //   type: "singleValueList",
    //   floatingLabelText: "Basis",
    //   hintText: "Select",
    //   fullWidth: true,
    //   required: false,
    //   numcols: 6,
    //   errorMessage: "Required!",
    //   gridDefination: {
    //     xs: 12,
    //     sm: 6,
    //   },
    //   formName: "propertyAddress",
    //   updateDependentFields: ({ formKey, field, dispatch, state }) => {
    //     dispatch(setFieldProperty("propertyAddress", "basis", "value", field.value));
    //     dispatch(prepareFinalObject("Properties[0].basis", field.value));
    //   },
    // },
    // inspDate: {
    //   id: "inspDate",
    //   type: "textfield",
    //   className: "pt-old-pid-text-field",
    //   jsonPath: "Properties[0].inspDate",
    //   floatingLabelText: "Insp Date",
    //   hintText: "",
    //   required: false,
    //   formatType: "date",
    //   numcols: 6,
    //   errorMessage: "Required!",
    //   errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
    //   maxLength: 64,
    //   formName: "propertyAddress",
    //   updateDependentFields: ({ formKey, field, dispatch, state }) => {
    //     dispatch(setFieldProperty("propertyAddress", "inspDate", "value", field.value));
    //     dispatch(prepareFinalObject("Properties[0].inspDate", field.value));
    //   },
    // },
    // volNo: {
    //   id: "volNo",
    //   type: "textfield",
    //   className: "pt-old-pid-text-field",
    //   jsonPath: "Properties[0].volNo",
    //   floatingLabelText: "Vol No.",
    //   hintText: "",
    //   required: false,
    //   numcols: 6,
    //   errorMessage: "Required!",
    //   errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
    //   maxLength: 64,
    //   formName: "propertyAddress",
    //   updateDependentFields: ({ formKey, field, dispatch, state }) => {
    //     dispatch(setFieldProperty("propertyAddress", "volNo", "value", field.value));
    //     dispatch(prepareFinalObject("Properties[0].volNo", field.value));
    //   },
    // },
    // pageNo: {
    //   id: "pageNo",
    //   type: "textfield",
    //   className: "pt-old-pid-text-field",
    //   jsonPath: "Properties[0].pageNo",
    //   floatingLabelText: "Page No.",
    //   hintText: "",
    //   required: false,
    //   numcols: 6,
    //   errorMessage: "Required!",
    //   errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
    //   toolTipMessage: "PT_OLDPID_TOOLTIP_MESSAGE",
    //   maxLength: 64,
    //   formName: "propertyAddress",
    //   updateDependentFields: ({ formKey, field, dispatch, state }) => {
    //     dispatch(setFieldProperty("propertyAddress", "pageNo", "value", field.value));
    //     dispatch(prepareFinalObject("Properties[0].pageNo", field.value));
    //   },
    // },
    ward: {
      id: "ward",
      jsonPath: "Properties[0].ward",
      type: "textfield",
      floatingLabelText: "Ward",
      fullWidth: true,
      disabled: true,
      className: "commmon_disabled_field",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      errorMessage: "ward required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      required: true,
      formName: "propertyAddress",
      updateDependentFields: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref2) {
          var formKey = _ref2.formKey,
              field = _ref2.field,
              dispatch = _ref2.dispatch,
              state = _ref2.state;
          var getStreetList;
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  dispatch(toggleSpinner());

                  getStreetList = function () {
                    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(name) {
                      var wardDropDownDataStatic, payload, selectedWard, streetDropDownDataNew;
                      return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              wardDropDownDataStatic = [];
                              _context.next = 3;
                              return (0, _api.httpRequest)("post", "/property-services/common/_streetMaster?wardNo=" + field.value, "", [], {});

                            case 3:
                              payload = _context.sent;
                              selectedWard = payload.data;
                              streetDropDownDataNew = [];

                              selectedWard.map(function (s) {
                                streetDropDownDataNew.push({
                                  name: s.streetName,
                                  code: s.street,
                                  value: s.street,
                                  label: s.streetName,
                                  active: "true"
                                });

                                return streetDropDownDataNew;
                              });
                              dispatch((0, _actions.setFieldProperty)("propertyAddress", "street", "dropDownData", streetDropDownDataNew));
                              return _context.abrupt("return", streetDropDownDataNew);

                            case 9:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, undefined);
                    }));

                    return function getStreetList(_x2) {
                      return _ref3.apply(this, arguments);
                    };
                  }();

                  setTimeout(function () {
                    return getStreetList();
                  }, 300);

                  if (!field.value) {
                    dispatch((0, _actions.setFieldProperty)("propertyAddress", "street", "dropDownData", ""));
                  }
                  dispatch(toggleSpinner());

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, undefined);
        }));

        return function updateDependentFields(_x) {
          return _ref.apply(this, arguments);
        };
      }()
    },
    street: {
      id: "street",
      jsonPath: "Properties[0].street",
      type: "textfield",
      floatingLabelText: "Street",
      hintText: "",
      numcols: 6,
      disabled: true,
      errorMessage: "street required!",
      className: "commmon_disabled_field",
      required: true,
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "street", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].street", field.value));
      }
    },
    premisesNo: {
      id: "premisesNo",
      type: "textfield",
      className: "commmon_disabled_field",
      jsonPath: "Properties[0].premisesNo",
      floatingLabelText: "Premise Number",
      hintText: "",
      required: true,
      disabled: true,
      numcols: 6,
      errorMessage: "premise no. required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      maxLength: 64,
      formName: "propertyAddress",
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "premisesNo", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].premisesNo", field.value));
      }
    },
    premisesType: {
      id: "premisesType",
      jsonPath: "Properties[0].premisesType",
      type: "textfield",
      floatingLabelText: "Premise Type",
      fullWidth: true,
      className: "commmon_disabled_field",
      required: true,
      disabled: true,
      numcols: 6,
      errorMessage: "Required!",
      formName: "propertyAddress",
      gridDefination: {
        xs: 12,
        sm: 6
      },
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "premisesType", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].premisesType", field.value));
      }
    }
  },
  afterInitForm: function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(action, store, dispatch) {
      var getWardList, state, wardDropDownDataStatic, payload, wardList, data, getStreetList, streetValue;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              getWardList = function getWardList() {
                wardList.map(function (w) {
                  wardDropDownDataStatic.push({
                    name: w.name,
                    code: w.code,
                    label: w.name,
                    value: w.code
                  });
                  return wardDropDownDataStatic;
                });
              };

              state = store.getState();
              wardDropDownDataStatic = [];
              _context4.next = 6;
              return (0, _api.httpRequest)("post", "egov-mdms-service/v1/_search", "", [], {
                MdmsCriteria: {
                  tenantId: "km",
                  moduleDetails: [{
                    moduleName: "PropertyTax",
                    masterDetails: [{
                      name: "ward"
                    }]
                  }]
                }
              });

            case 6:
              payload = _context4.sent;
              wardList = payload.MdmsRes.PropertyTax.ward;


              getWardList();
              dispatch((0, _actions.setFieldProperty)("propertyAddress", "ward", "dropDownData", wardDropDownDataStatic));
              dispatch((0, _actions.setFieldProperty)("propertyAddress", "premisesType", "dropDownData", premisesTypeStaticData));
              dispatch((0, _actions.setFieldProperty)("propertyAddress", "basis", "dropDownData", basisData));
              data = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "Properties[0]");

              getStreetList = function () {
                var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(name) {
                  var payload, selectedWard, streetDropDownDataNew;
                  return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return (0, _api.httpRequest)("post", "/property-services/common/_streetMaster?wardNo=" + name, "", [], {});

                        case 2:
                          payload = _context3.sent;
                          selectedWard = payload.data;
                          streetDropDownDataNew = [];

                          selectedWard.map(function (s) {
                            streetDropDownDataNew.push({
                              name: s.streetName,
                              code: s.street,
                              value: s.street,
                              label: s.streetName,
                              active: "true"
                            });

                            return streetDropDownDataNew;
                          });
                          dispatch((0, _actions.setFieldProperty)("propertyAddress", "street", "dropDownData", streetDropDownDataNew));
                          dispatch((0, _actions2.prepareFinalObject)("streetWardList", streetDropDownDataNew));
                          return _context3.abrupt("return", streetDropDownDataNew);

                        case 9:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, undefined);
                }));

                return function getStreetList(_x6) {
                  return _ref8.apply(this, arguments);
                };
              }();

              streetValue = getStreetList(data.ward);

              //   dispatch(setFieldProperty("propertyAddress", "street", "dropDownData", streetValue));

              dispatch((0, _actions.setFieldProperty)("propertyAddress", "ward", "value", data.ward ? data.ward.toString() : ""));
              dispatch((0, _actions.setFieldProperty)("propertyAddress", "street", "value", data.street ? data.street.toString() : ""));
              dispatch((0, _actions.setFieldProperty)("propertyAddress", "premisesNo", "value", data.premisesNo ? data.premisesNo.toString() : ""));
              dispatch((0, _actions.setFieldProperty)("propertyAddress", "premisesType", "value", data.premisesType ? data.premisesType : ""));
              dispatch((0, _actions.setFieldProperty)("propertyAddress", "inspector", "value", data.inspector ? data.inspector.toString() : ""));
              dispatch((0, _actions.setFieldProperty)("propertyAddress", "basis", "value", data.basis ? data.basis.toString() : ""));
              dispatch((0, _actions.setFieldProperty)("propertyAddress", "inspDate", "value", data.inspDate ? data.inspDate.toString() : ""));
              dispatch((0, _actions.setFieldProperty)("propertyAddress", "volNo", "value", data.volNo ? data.volNo : ""));
              dispatch((0, _actions.setFieldProperty)("propertyAddress", "pageNo", "value", data.pageNo ? data.pageNo : ""));

              dispatch((0, _actions2.prepareFinalObject)("Properties[0].ward", data.ward ? data.ward.toString() : ""));
              dispatch((0, _actions2.prepareFinalObject)("Properties[0].streetName", data.streetName ? data.streetName.toString() : ""));
              dispatch((0, _actions2.prepareFinalObject)("Properties[0].premisesNo", data.premisesNo ? data.premisesNo.toString() : ""));
              dispatch((0, _actions2.prepareFinalObject)("Properties[0].premisesType", data.premisesType ? data.premisesType : ""));
              dispatch((0, _actions2.prepareFinalObject)("Properties[0].inspector", data.inspector ? data.inspector.toString() : ""));
              dispatch((0, _actions2.prepareFinalObject)("Properties[0].basis", data.basis ? data.basis.toString() : ""));
              dispatch((0, _actions2.prepareFinalObject)("Properties[0].inspDate", data.inspDate ? data.inspDate.toString() : ""));
              dispatch((0, _actions2.prepareFinalObject)("Properties[0].volNo", data.volNo ? data.volNo : ""));
              dispatch((0, _actions2.prepareFinalObject)("Properties[0].pageNo", data.pageNo ? data.pageNo : ""));
              return _context4.abrupt("return", action);

            case 36:
              _context4.prev = 36;
              _context4.t0 = _context4["catch"](0);

              console.log(_context4.t0);
              return _context4.abrupt("return", action);

            case 40:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, undefined, [[0, 36]]);
    }));

    return function afterInitForm(_x3, _x4, _x5) {
      return _ref7.apply(this, arguments);
    };
  }(),

  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPayMutation/propertyAddress.js
// module id = 2070
// module chunks = 1137